import React, { useState } from "react";
import DocumentHeader from "./DocumentHeader";
import useDocumentList from "../../hooks/useDocumentList";
import InvoiceDataGrid from "./InvoiceDataGrid";
import InvoiceActivityLogs from "./InvoiceActivityLogs";
import checkIfUserHasAccess from "../common/UserCheckAccess";
import canUserSeeThis from "../common/CheckCanUserSeeThis";
import { exportInvoiceToExcel } from "./exportInvoiceToExcel";

const SalesOrderList = () => {
  const [p1Value, setP1Value] = useState("OPEN");
  const [modalType, setModalType] = useState("close");

  const {
    config,
    searchTerm,
    setSearchTerm,
    searchType,
    setSearchType,
    showSidebar,
    setShowSidebar,
    columnVisibilityModel,
    setColumnVisibilityModel,
    documentData,
    columns,
    rows,
    selectionModel,
    setSelectionModel,
    selectedRowData,
    setSelectedRowData,
    loading,
    handleEdit,
    exportDocumentList,
    handleView,
    pageNumber,
    setPageNumber,
    currentEnd,
    currentStart,
    totalCount,
    refreshDocumentList,
    isSalesOrderEditable,
  } = useDocumentList({
    docType: "SORD",
    docLabel: "Sales Order",
    p1Value,
    p2Value: "-",
    docNoField: "SO NO",
    editRoute: "/sales_order",
    initialSearchType: "-",
    screenCode: "SOCOUNT",
  });

  const handleExport = () => {
    exportDocumentList();
  };

  const handleExportItems = async () => {
    const soNo = selectedRowData?.["SO NO"];
    if (!soNo) {
      alert("Please select a sales order first");
      return;
    }
    try {
      const url = `${config.BASE_URL}/api/DocumentEditDetails/${config.COMPANY_CODE}/SORD/${soNo}/${config.DEPARTMENT_NO}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch item data");
      const itemData = await response.json();
      if (itemData && itemData.length > 0) {
        exportInvoiceToExcel(itemData, config.COMPANY_NAME, "SORD");
      } else {
        alert("No item data available for this sales order");
      }
    } catch (err) {
      console.error("Error exporting items:", err);
      alert("Failed to export items. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <DocumentHeader
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        BASE_URL={config.BASE_URL}
        COMPANY_CODE={config.COMPANY_CODE}
        DEPARTMENT={config.DEPARTMENT_NO}
        title={"Sales Order List"}
        searchTerm={searchTerm}
        searchType={searchType}
        setSearchTerm={setSearchTerm}
        setSearchType={setSearchType}
        filteredDocs={documentData}
        showType={p1Value}
        setShowType={setP1Value}
        total={totalCount}
        documentType={"SALES_ORDER"}
        onExport={handleExport}
        onExportItems={handleExportItems}
        config={config}
        selectedRowData={selectedRowData}
        showFilter={true}
        doctype="SO NO"
      />
      <div className="max-w-full mx-auto py-2 space-y-4">
        <div className="grid grid-cols-12 gap-4">
          {showSidebar && (
            <InvoiceActivityLogs
              invoiceId={selectedRowData["SO NO"]}
              COMPANY_CODE={config.COMPANY_CODE}
              BASE_URL={config.BASE_URL}
              modificationType={"SOTIMELINE"}
              printType={"SOTPRINTIMELINE"}
              DEPARTMENT={config.DEPARTMENT_NO}
            />
          )}
          <div
            className={`col-span-12 ${showSidebar ? "lg:col-span-9" : "lg:col-span-12"
              } transition-all duration-300`}
          >
            <InvoiceDataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              selectionModel={selectionModel}
              setSelectionModel={setSelectionModel}
              setSelectedRowData={setSelectedRowData}
              selectedRowData={selectedRowData}
              onEdit={handleEdit}
              onView={handleView}
              columnVisibilityModel={columnVisibilityModel}
              setColumnVisibilityModel={setColumnVisibilityModel}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              currentStart={currentStart}
              currentEnd={currentEnd}
              totalCount={totalCount}
              showSidebar={showSidebar}
              docLabel={"SO"}
              enableF5Action={
                config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN"
                  ? true
                  : canUserSeeThis("SG")
              }
              config={config}
              refreshDocumentList={refreshDocumentList}
              f5Mode={"SOSETTLEMENT"}
              modalType={"close"}
              setModalType={setModalType}
              showApproveReject={
                canUserSeeThis("LY") ||
                canUserSeeThis("YT") ||
                config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN"
              }
              reviewMode="SALESORDER"
              isSalesOrderEditable={isSalesOrderEditable}
              showEdit={config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN" ||
                canUserSeeThis("AA")} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesOrderList;
